<template>
  <div>
    <IsiTeks halaman="petunjuk-penggunaan" />
  </div>
</template>

<script>
import IsiTeks from '../components/IsiTeks'

export default {
  components: {
    IsiTeks
  }  
}
</script>